// src/redux/slices/profileSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { getProfile } from '../apis/getProfile';
import { normalizeBusinessProfile } from '../utils/isBusinessProfileEmpty';
import { logout } from './authSlice';

const guestProfileState = {
    loading: false,
    data: null,
    error: null,
};

// Async thunk to fetch profile data
export const fetchBusinessDetails = createAsyncThunk(
    'profile/fetchBusinessDetails',
    async (_, { rejectWithValue, getState }) => {
        if (!getState().auth.user) {
            return null;
        }

        try {
            const data = await getProfile();
            return normalizeBusinessProfile(data);
        } catch (error) {
            if (error?.response?.status === 404) {
                return null;
            }
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        loading: true,
        data: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBusinessDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBusinessDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchBusinessDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Something went wrong';
            })
            .addCase(logout, () => guestProfileState);
    },
});

export default profileSlice.reducer;
